import {Component, Input, OnInit} from '@angular/core';
import {ResourceModel} from "../../../../../../../core/models/resources/resource.model";

@Component({
    selector: 'app-statuses-table',
    templateUrl: './statuses-table.component.html',
    styleUrls: ['./statuses-table.component.scss'],
    standalone: false
})
export class StatusesTableComponent {
  @Input() resource: ResourceModel;
}
